import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { UnlinkLicense as UnlinkLicenseReducer } from '../../reducers/r_index';
import { GetLicenses as GetLicensesReducer } from '../../reducers/r_index';
import { FilterLicenses as FilterLicensesReducer } from '../../reducers/r_index';

//Components
import DisassociaLicenzaCmp from '../../components/gestione_licenze/DisassociaLicenzaCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class DisassociaLicenza extends Component {

    render() {
        const { ...props } = this.props;

        return (
            <DisassociaLicenzaCmp {...props} />
        );

    }
}

DisassociaLicenza.propTypes = {
    //unlinkLicense
    unlinkLicense: PropTypes.func.isRequired,
    unlinkLicenseRequestStatus: PropTypes.string.isRequired,
    unlinkLicenseErrorMessage: PropTypes.string,

    showDisassociaDialog: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,

    selected_license: PropTypes.shape({}).isRequired,

    refreshLicenses: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,

};


const mapDispatchToProps = dispatch => ({
    unlinkLicense: (pk) => { dispatch(UnlinkLicenseReducer.creators.unlinkLicenseRequest(pk)) },

    showDisassociaDialog: () => { dispatch(UnlinkLicenseReducer.creators.showDisassociaDialog()); },

    refreshLicenses: (codiceUtente) => { dispatch(GetLicensesReducer.creators.getLicensesRequest(codiceUtente)); },
    resetFilters: () => { dispatch(FilterLicensesReducer.creators.resetFilters()) },
});

const mapStateToProps = state => ({
    isOpen: state['unlink-license'].isOpen,
    unlinkLicenseRequestStatus: state['unlink-license'].status,
    unlinkLicenseErrorMessage: state['unlink-license'].error,

    selectedRowIndex: state['filtro-licenze'].selectedRowIndex,

    selected_license: state['filtro-licenze'].selected_license,

    codiceUtente: state['logged-user'].codiceUtente,

});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(DisassociaLicenza));